<template>
  <div class="bimface-annotation">
    <!-- 批注列表面板 -->
    <div class="annotation-panel" @click.stop>
      <!-- 头部 -->
      <div class="annotation-header">
        <span class="header-title">批注</span>
        <i class="iconfont icon-changguitubiao-guanbi close-icon" @click="handleClose" />
      </div>

      <!-- 新增批注按钮 -->
      <div class="annotation-actions">
        <el-button
          type="primary"
          plain
          class="add-btn"
          :disabled="isInAnnotation"
          @click="toAddAnnotation"
        >
          批注
        </el-button>
      </div>

      <!-- 批注列表 -->
      <div class="annotation-list" @scroll="handleScroll">
        <ul v-if="annotationList.length" class="list-content">
          <li
            v-for="item in annotationList"
            :key="item.id"
            class="annotation-item"
          >
            <!-- 批注主体部分（包含内容和操作按钮） -->
            <div
              class="annotation-main"
              :class="{ 'active': activeAnnotationId === item.id }"
            >
              <!-- 左侧激活长条 -->
              <div class="active-bar"></div>

              <!-- 批注内容 -->
              <div class="annotation-content" @click="handleAnnotationClick(item, $event)">
                <img :src="item.creator.avatar || defaultAvatar" class="user-avatar" />
                <div class="content-right">
                  <div class="user-info">
                    <span class="user-name" :title="item.creator.name">{{ item.creator.name }}</span>
                    <span class="create-time">{{ $fmtTime(item.createTime, 'YYYY/MM/DD') }}</span>
                  </div>
                  <div class="content-text">{{ item.content }}</div>
                  <!-- 辅助圈注截图 -->
                  <div v-if="item.screenshot" class="screenshot-wrapper">
                    <img :src="$hosts.static(item.screenshot)" class="screenshot-img" />
                  </div>
                </div>
              </div>

              <!-- 操作区域 -->
              <div class="annotation-actions-bar">
                <div class="action-right">
                  <span class="action-btn reply-btn" :class="{ 'active': item.showReplies }" @click="toggleReply(item)">
                    <i class="iconfont icon-pinglun" />
                    <span class="reply-count">({{ item.replies ? item.replies.length : 0 }})</span>
                  </span>
                  <el-dropdown v-if="canDeleteAnnotation(item)" trigger="click" @command="(cmd) => handleCommand(cmd, item)">
                    <span class="action-btn">
                      <i class="iconfont icon-gengduo" />
                    </span>
                    <el-dropdown-menu slot="dropdown" class="dark-style">
                      <el-dropdown-item command="delete">
                        <span class="red-bg">删除</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>

            <!-- 回复列表 -->
            <div v-if="item.showReplies" class="reply-list">
              <div v-for="reply in item.replies" :key="reply.id" class="reply-item">
                <img :src="reply.creator.avatar || defaultAvatar" class="user-avatar" />
                <div class="content-right">
                  <div class="user-info">
                    <div class="user-info-left">
                      <span class="user-name" :title="reply.creator.name">{{ reply.creator.name }}</span>
                      <span class="create-time">{{ $fmtTime(reply.createTime, 'YYYY/MM/DD') }}</span>
                    </div>
<!--                    <el-dropdown v-if="canDeleteReply(item, reply)" trigger="click" @command="(cmd) => handleReplyCommand(cmd, item, reply)">-->
<!--                      <span class="action-btn">-->
<!--                        <i class="iconfont icon-gengduo" />-->
<!--                      </span>-->
<!--                      <el-dropdown-menu slot="dropdown" class="dark-style">-->
<!--                        <el-dropdown-item command="delete">-->
<!--                          <span class="red-bg">删除</span>-->
<!--                        </el-dropdown-item>-->
<!--                      </el-dropdown-menu>-->
<!--                    </el-dropdown>-->
                    <div>
                      <el-button v-if="canDeleteReply(item, reply)" type="text" class="icon-delete" icon="el-icon-delete" @click="()=>deleteReply(item, reply)"></el-button>
                    </div>
                  </div>
                  <div class="reply-content">{{ reply.content }}</div>
                </div>
              </div>

              <!-- 回复输入框 -->
              <div v-if="!item.replies || item.replies.length < 20" class="reply-input-wrapper">
                <el-input
                  v-model="item.replyContent"
                  type="textarea"
                  :autosize="{ minRows: 1, maxRows: 4 }"
                  resize="none"
                  placeholder="请输入内容"
                  maxlength="200"
                  @keydown.enter.native="handleReplyKeydown($event, item)"
                />
                <i
                  class="iconfont icon-fasong1 send-icon"
                  :class="{ 'disabled': !item.replyContent || item.replyLoading }"
                  @click="handleReply(item)"
                />
              </div>
              <div v-else class="reply-limit-text">回复数量已到上限</div>
            </div>
          </li>
        </ul>

        <!-- 空状态 -->
        <div v-else-if="!loading" class="empty-content">
          <img src="@/assets/img/data_empty.png" width="100" alt="" />
          <p>暂无内容</p>
        </div>

        <!-- 加载状态 -->
        <div v-if="loading" class="loading-text">加载中...</div>
        <div v-else-if="noMore && annotationList.length" class="loading-text">已经到底了</div>
      </div>
    </div>

    <!-- 批注编辑对话框 -->
    <div
      v-if="showEditDialog"
      class="annotation-dialog"
      :style="dialogPosition"
    >
      <div class="dialog-content">
        <el-input
          v-model="annotationForm.content"
          type="textarea"
          :rows="3"
          placeholder="请输入批注内容"
          maxlength="200"
          show-word-limit
          resize="none"
        />

        <div class="dialog-actions">
          <div class="action-left">
            <img v-if="annotationForm.screenshot" :src="annotationForm.screenshot" class="screenshot-img-sm" alt="" />
            <el-button class="assist-btn" size="small" type="text" @click="handleAssistAnnotation">
              <i class="iconfont icon-fuzhuquanzhu" />
              <span v-if="!annotationForm.screenshot">辅助圈注</span>
            </el-button>
          </div>
          <div class="action-right">
            <el-button size="small" @click="cancelEdit">取消</el-button>
            <el-button
              type="primary"
              size="small"
              :disabled="!annotationForm.content"
              :loading="saving"
              @click="saveAnnotation"
            >
              确定
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'

export default {
  name: 'BimfaceAnnotation',
  props: {
    spaceId: [String, Number],
    fileId: [String, Number],
    fromPage: String,
    fileType: String,
    viewer3D: Object,
    app: Object,
    isInAnnotation: Boolean,
    shareCode: [String, Number], // 分享码，分享页模式时使用
  },
  data() {
    return {
      annotationList: [],
      loading: false,
      noMore: false,
      pageNo: 1,
      pageSize: 10,
      totalCount: 0,
      defaultAvatar: require('@/assets/img/default-avstar.png'),
      showEditDialog: false,
      dialogPosition: {},
      annotationForm: {
        elementId: '',
        content: '',
        viewPoint: null,
        assistAnnotation: null,
        screenshot: '',
      },
      saving: false,
      annotationToolbar: null, // 批注工具栏
      isAssistAnnotation: false, // 是否正在辅助圈注
      activeAnnotationId: null, // 当前激活的批注ID
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user'
    }),
    // 是否为分享页模式
    isShareMode() {
      return this.fromPage === 'SHARE'
    },
    // 是否已登录
    isLoggedIn() {
      return this.user && this.user.id
    },
  },
  mounted() {
    this.loadAnnotationList()
    // 添加全局点击监听，用于取消批注激活状态
    document.addEventListener('click', this.handleGlobalClick)
    // 创建辅助圈注工具条
    this.createAnnotationToolbar()
  },
  beforeDestroy() {
    // 移除全局点击监听
    document.removeEventListener('click', this.handleGlobalClick)
  },
  methods: {
    // 判断是否可以删除批注（只有创建人可以删除）
    canDeleteAnnotation(annotation) {
      return this.user && annotation.creator && String(annotation.creator.id) === String(this.user.strId)
    },

    // 判断是否可以删除回复（批注创建人或回复者本人可以删除）
    canDeleteReply(annotation, reply) {
      if (!this.user || !reply.creator) {
        return false
      }
      return String(reply.creator.id) === String(this.user.strId) || String(annotation.creator.id) === String(this.user.strId)
    },

    // 关闭面板
    handleClose() {
      // 退出辅助圈注状态
      this.exitAssistAnnotation();
      this.$emit('close')
    },

    // 加载批注列表
    async loadAnnotationList(isLoadMore = false) {
      if (this.loading) return

      try {
        this.loading = true
        const query = {
          file_id: this.fileId,
          type: this.fileType,
          page_no: this.pageNo,
          page_size: this.pageSize,
        }

        let list = []
        let totalCount = 0

        // 根据是否为分享页模式选择不同的接口
        if (this.isShareMode) {
          // 分享页模式：使用分享页接口
          const res = await this.$api.annotation.listByShareCode(this.shareCode, query)
          list = res.list || []
          totalCount = res.totalCount || 0
        } else {
          // 普通模式：使用普通接口
          const res = await this.$api.annotation.list(this.spaceId, query)
          list = res.list || []
          totalCount = res.totalCount || 0
        }

        // 为每个批注添加响应式属性
        list.forEach(item => {
          this.$set(item, 'showReplies', false)
          this.$set(item, 'replyContent', '')
          this.$set(item, 'replyLoading', false)
        })

        if (isLoadMore) {
          this.annotationList = [...this.annotationList, ...list]
        } else {
          this.annotationList = list
        }

        this.totalCount = totalCount
        this.noMore = this.annotationList.length >= this.totalCount
      } catch (error) {
        this.$message.error('获取批注列表失败')
      } finally {
        this.loading = false
      }
    },

    // 滚动加载
    handleScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      if (scrollTop + clientHeight >= scrollHeight - 10 && !this.loading && !this.noMore) {
        this.pageNo++
        this.loadAnnotationList(true)
      }
    },

    // 新增批注
    toAddAnnotation() {
      if(this.isAssistAnnotation){
        return
      }
      // 分享页模式下，未登录时触发登录
      if (this.isShareMode && !this.isLoggedIn) {
        this.$emit('require-login')
        return
      }
      // 退出辅助圈注状态
      this.exitAssistAnnotation();
      this.$emit('add-annotation')
    },

    // 点击批注内容（激活并恢复视点）
    handleAnnotationClick(item, event) {
      // 阻止事件冒泡到全局
      if (event) {
        event.stopPropagation()
      }
      if(this.activeAnnotationId === item.id){
        return
      }
      // 退出批注状态
      this.cancelEdit()
      // 先清除辅助圈注
      this.exitAssistAnnotation();

      // 设置激活状态
      this.activeAnnotationId = item.id

      const detail = item.detail || {}

      // 如果有辅助圈注信息
      if (detail.assistAnnotation) {
        const annotationState = JSON.parse(detail.assistAnnotation) || {}
        this.annotationToolbar && this.annotationToolbar.getAnnotationManager().setState(annotationState)
      } else if (detail.viewPoint) {
        // 如果有视点信息
        const state = JSON.parse(detail.viewPoint) || {}
        this.viewer3D.setState(state)
      }
      // 埋点
      this.$tracks({
          event: 'viewAnnotation',
          params: {
            g_c_space_id: this.spaceId || null,
            g_c_file_id: this.fileId,
            g_c_file_type: this.fileType,
          }
        })
    },

    // 全局点击处理，取消批注激活状态
    handleGlobalClick() {
      this.activeAnnotationId = null
    },

    // 显示/隐藏回复
    toggleReply(item) {
      this.$set(item, 'showReplies', !item.showReplies)
    },

    // 批注操作
    handleCommand(command, item) {
      if (command === 'delete') {
        this.deleteAnnotation(item)
      }
    },

    // // 回复操作
    // handleReplyCommand(command, annotation, reply) {
    //   if (command === 'delete') {
    //     this.deleteReply(annotation, reply)
    //   }
    // },

    // 删除批注
    deleteAnnotation(item) {
      this.$confirm('是否确认删除批注及所有回复？', '', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        customClass: 'dark-confirm delete-warning'
      }).then(async () => {
        try {
          // 根据是否为分享页模式选择不同的接口
          if (this.isShareMode) {
            await this.$api.annotation.deleteAnnotationByShareCode(this.shareCode, item.id)
          } else {
            await this.$api.annotation.deleteAnnotation(this.spaceId, item.id)
          }
          this.$message.success('删除成功')
          // 埋点
          this.$tracks({
            event: 'deleteAnnotation',
            params: {
              g_c_space_id: this.spaceId || null,
              g_c_file_id: this.fileId,
              g_c_file_type: this.fileType,
            }
          })
          this.pageNo = 1
          this.loadAnnotationList()
        } catch (error) {
          const errors = {
            'comment.not.exist': '批注不存在'
          }
          if(error.code === 'comment.not.exist'){
            this.pageNo = 1
            this.loadAnnotationList()
          }
          this.$matchError(error.code, errors, '删除失败')
        }
      }).catch(() => {})
    },

    // 处理回复输入框的回车键
    handleReplyKeydown(event, item) {
      // 如果按的是 Shift+Enter，允许换行
      if (event.shiftKey) {
        return
      }
      // 如果只按了 Enter，阻止默认行为（换行），并发送回复
      event.preventDefault()
      this.handleReply(item)
    },

    // 回复批注
    async handleReply(item) {
      if (!item.replyContent || !item.replyContent.trim() || item.replyLoading) {
        return
      }

      // 分享页模式下，未登录时触发登录
      if (this.isShareMode && !this.isLoggedIn) {
        this.$emit('require-login')
        return
      }

      try {
        this.$set(item, 'replyLoading', true)
        const params = {
          content: item.replyContent.trim(),
        }

        // 根据是否为分享页模式选择不同的接口
        if (this.isShareMode) {
          await this.$api.annotation.replyByShareCode(this.shareCode, item.id, params)
        } else {
          await this.$api.annotation.reply(this.spaceId, item.id, params)
        }
        // 埋点
        this.$tracks({
          event: 'replyAnnotation',
          params: {
            g_c_space_id: this.spaceId || null,
            g_c_file_id: this.fileId,
            g_c_file_type: this.fileType,
          }
        })
        this.$set(item, 'replyContent', '')

        // 重新加载列表
        this.pageNo = 1
        await this.loadAnnotationList()

        // 展开回复列表
        const updatedItem = this.annotationList.find(a => a.id === item.id)
        if (updatedItem) {
          this.$set(updatedItem, 'showReplies', true)
        }
      } catch (error) {
        const errors = {
          'comment.not.exist': '批注不存在'
        }
        if(error.code === 'comment.not.exist'){
          this.pageNo = 1
          await this.loadAnnotationList()
        }
        this.$matchError(error.code, errors, '回复失败')
      } finally {
        this.$set(item, 'replyLoading', false)
      }
    },

    // 删除回复
    deleteReply(annotation, reply) {
      this.$confirm('是否确认删除回复？', '', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        customClass: 'dark-confirm delete-warning'
      }).then(async () => {
        try {
          // 根据是否为分享页模式选择不同的接口
          if (this.isShareMode) {
            await this.$api.annotation.deleteReplyByShareCode(this.shareCode, annotation.id, reply.id)
          } else {
            await this.$api.annotation.deleteReply(this.spaceId, annotation.id, reply.id)
          }
          this.$message.success('删除成功')
          // 埋点
          this.$tracks({
            event: 'deleteAnnotationReply',
            params: {
              g_c_space_id: this.spaceId || null,
              g_c_file_id: this.fileId,
              g_c_file_type: this.fileType,
            }
          })
          this.pageNo = 1
          this.loadAnnotationList()
        } catch (error) {
          const errors = {
            'reply.not.exist': '回复不存在'
          }
          if(error.code === 'reply.not.exist'){
            this.pageNo = 1
            await this.loadAnnotationList()
          }
          this.$matchError(error.code, errors, '删除失败')
        }
      }).catch(() => {})
    },

    // 显示批注编辑对话框（由父组件调用）
    showAnnotationDialog(data) {
      this.showEditDialog = true
      this.annotationForm.elementId = data.elementId

      // 设置对话框位置（鼠标点击位置右下方）
      const offsetX = 20
      const offsetY = 20
      const dialogWidth = 260
      const dialogHeight = 156

      // 计算初始位置
      let left = data.position.x + offsetX
      let top = data.position.y + offsetY

      // 边界检查，确保对话框不超出屏幕
      const windowWidth = window.innerWidth
      const windowHeight = window.innerHeight

      // 右边界检查
      if (left + dialogWidth > windowWidth) {
        left = windowWidth - dialogWidth - 10
      }
      // 左边界检查
      if (left < 10) {
        left = 10
      }

      // 底边界检查
      if (top + dialogHeight > windowHeight) {
        top = windowHeight - dialogHeight - 10
      }
      // 顶边界检查
      if (top < 10) {
        top = 10
      }

      this.dialogPosition = {
        position: 'fixed',
        left: `${left}px`,
        top: `${top}px`,
      }
    },

    // 辅助圈注
    handleAssistAnnotation() {
      try {
        // 临时关闭编辑对话框
        this.showEditDialog = false
        this.$emit('change-mouse-default')
        this.createAnnotationToolbar()
        if(!this.isAssistAnnotation){
          this.app.getToolbar("MainToolbar").hide();
          this.annotationToolbar.show()
          // 为了确保工具栏出现，手动显示工具栏
          this.$nextTick(() => {
            const annotationBtn = document.querySelector('.bf-annotation')
              if (annotationBtn) {
                annotationBtn.style.display = 'block'
              }
          })
          this.isAssistAnnotation = true
        }
      } catch (error) {
        console.error('进入辅助圈注模式失败', error)
        this.$message.error('进入辅助圈注模式失败')
        // 重新显示编辑对话框
        this.showEditDialog = true
      }
    },
    // 创建批注工具条
    createAnnotationToolbar() {
      if (!this.annotationToolbar) {
        // 创建批注工具条的配置
        const config = new Glodon.Bimface.Plugins.Annotation.AnnotationToolbarConfig();
        config.viewer = this.viewer3D;
        // 创建批注工具条
        this.annotationToolbar = new Glodon.Bimface.Plugins.Annotation.AnnotationToolbar(config);
        this.annotationToolbar.getAnnotationManager().setFillColor(new Glodon.Web.Graphics.Color(255, 0, 0, 0.3));

        // 注册批注工具条的监听事件
        this.annotationToolbar.addEventListener(Glodon.Bimface.Plugins.Annotation.AnnotationToolbarEvent.Saved, this.onAnnotationSaved);
        this.annotationToolbar.addEventListener(Glodon.Bimface.Plugins.Annotation.AnnotationToolbarEvent.Cancelled, this.exitAnnotation);
      }
    },
    // 辅助圈注-保存并退出
    onAnnotationSaved(){
      const that = this
      this.annotationForm.assistAnnotation = this.annotationToolbar.getAnnotationManager().getCurrentState();
      // 批注导出快照
      this.annotationToolbar.getAnnotationManager().createSnapshot(function (img) {
        that.annotationForm.screenshot = img
      });
      this.exitAnnotation();
    },
    // 辅助圈注-取消
    exitAnnotation(){
      this.$emit('change-mouse')
      this.exitAssistAnnotation();
      // 重新显示编辑对话框
      this.showEditDialog = true
    },
    // 退出圈注状态
    exitAssistAnnotation(){
      this.annotationToolbar && this.annotationToolbar.getAnnotationManager().exit();
      // 工具栏不会消失，需要手动隐藏
      // 找打.bf-annotation元素，手动将该元素隐藏
      this.$nextTick(() => {
        const annotationBtn = document.querySelector('.bf-annotation')
          if (annotationBtn) {
            annotationBtn.style.display = 'none'
          }
      })
      this.app.getToolbar("MainToolbar").show();
      this.isAssistAnnotation = false
    },

    // 取消编辑
    cancelEdit() {
      this.showEditDialog = false
      this.annotationForm = {
        elementId: '',
        content: '',
        viewPoint: null,
        assistAnnotation: null,
        screenshot: '',
      }
      // 通知父组件退出批注模式
      this.$emit('cancel-annotation')
    },

    // 保存批注
    async saveAnnotation() {
      if (!this.annotationForm.content || !this.annotationForm.content.trim()) {
        return
      }

      // 分享页模式下，未登录时触发登录
      if (this.isShareMode && !this.isLoggedIn) {
        this.$emit('require-login')
        this.showEditDialog = false
        return
      }

      try {
        this.saving = true
        // 如果没有辅助圈注信息，保存当前视点
        let viewPoint = null
        if (!this.annotationForm.assistAnnotation) {
          viewPoint = this.viewer3D.getCurrentState()
        }
        const annotation = this.annotationForm.assistAnnotation
        const params = {
          fileId: this.fileId - 0,
          type: this.fileType,
          elementId: this.annotationForm.elementId,
          content: this.annotationForm.content.trim(),
          viewPoint: viewPoint ? JSON.stringify(viewPoint) : null,
          assistAnnotation: annotation ? JSON.stringify(annotation) : null,
          screenshot: this.annotationForm.screenshot || null,
        }

        // 根据是否为分享页模式选择不同的接口
        if (this.isShareMode) {
          await this.$api.annotation.createByShareCode(this.shareCode, params)
        } else {
          await this.$api.annotation.create(this.spaceId, params)
        }

        this.$message.success('创建成功')
        // 埋点
        this.$tracks({
          event: 'newAnnotation',
          params: {
            g_c_space_id: this.spaceId || null,
            g_c_file_id: this.fileId,
            g_c_file_type: this.fileType,
          }
        })

        // 关闭对话框
        this.showEditDialog = false
        this.annotationForm = {
          elementId: '',
          content: '',
          viewPoint: null,
          assistAnnotation: null,
          screenshot: '',
        }
        // 重新加载列表
        this.pageNo = 1
        this.loadAnnotationList().catch()
        // 通知父组件退出批注模式
        this.$emit('annotation-created')
      } catch (error) {
        this.$matchError(error.code, {}, '创建失败')
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.bimface-annotation {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 100;

  .annotation-panel {
    width: 324px;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    border-left: 1px solid #4F4F4F;
    display: flex;
    flex-direction: column;

    .annotation-header {
      flex: 0 0 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      border-bottom: 1px solid #4F4F4F;
      background: #000000;

      .header-title {
        color: #FFFFFF;
      }

      .close-icon {
        color: rgba(255, 255, 255, 0.65);
        font-size: 14px;
        cursor: pointer;
        color: #FFFFFF;
      }
    }

    .annotation-actions {
      flex: 0 0 auto;
      padding: 12px;

      .add-btn {
        width: 60px;
        height: 32px;
      }

      .login-tip {
        color: rgba(255, 255, 255, 0.45);
        font-size: 12px;
        margin-top: 8px;
        text-align: center;
      }
    }

    .annotation-list {
      flex: 1;
      overflow-y: auto;

        .list-content {
          list-style: none;
          padding: 0;
          margin: 0;

          .annotation-item {
            padding: 16px 0;
            border-bottom: 1px solid #4F4F4F;

            // 批注主体部分（不包含回复列表）
            .annotation-main {
              padding: 6px 0;
              position: relative;
              transition: background-color 0.2s;

              // 左侧激活长条，默认隐藏
              .active-bar {
                position: absolute;
                left: 0;
                top: 0;
                width: 4px;
                height: 100%;
                background-color: #11DAB7;
                opacity: 0;
                transition: opacity 0.2s;
              }

              // 激活状态
              &.active {
                background-color: #4F4F4F;

                .active-bar {
                  opacity: 1;
                }
              }
            }

            .annotation-content {
              display: flex;
              gap: 12px;
              padding: 0 12px;
              cursor: pointer;

              &:hover {
                opacity: 0.8;
              }

              .user-avatar {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                flex-shrink: 0;
              }

              .content-right {
                flex: 1;
                min-width: 0;

                .user-info {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  margin-bottom: 8px;

                  .user-name {
                    color: rgba(255, 255, 255, 0.9);
                    font-size: 14px;
                    line-height: 1.4;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 150px;
                  }

                  .create-time {
                    color: rgba(255, 255, 255, 0.45);
                    font-size: 12px;
                    line-height: 1.4;
                    white-space: nowrap;
                    flex-shrink: 0;

                    &::before {
                      content: '·';
                      margin-right: 8px;
                    }
                  }
                }

                .content-text {
                  color: rgba(255, 255, 255, 0.85);
                  font-size: 14px;
                  line-height: 1.6;
                  word-break: break-all;
                  margin-bottom: 8px;
                }

                .screenshot-wrapper {
                  width: 100%;
                  overflow: hidden;
                  background: rgba(214, 224, 235, 1);

                  .screenshot-img {
                    width: 100%;
                    display: block;
                  }
                }
              }
            }

            .annotation-actions-bar {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding: 8px 12px 0;

              .action-right {
                display: flex;
                align-items: center;
                gap: 16px;
              }

              .action-btn {
                color: rgba(255, 255, 255, 0.65);
                font-size: 16px;
                cursor: pointer;
                display: inline-flex;
                gap: 4px;

                &:hover {
                  color: #11DAB7;
                }

                &.reply-btn {
                  .reply-count {
                    font-size: 13px;
                  }

                  &.active {
                    color: #11DAB7;
                  }
                }
              }
            }

            // 回复列表（与批注主体分离，不包含在激活状态中）
            .reply-list {
              margin-top: 10px;
              padding: 0 12px 0 56px;

              .reply-item {
                display: flex;
                gap: 12px;
                margin-bottom: 12px;

                .user-avatar {
                  width: 32px;
                  height: 32px;
                  border-radius: 50%;
                  flex-shrink: 0;
                }

                .content-right {
                  flex: 1;
                  min-width: 0;

                  .user-info {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 6px;

                    .user-info-left {
                      display: flex;
                      align-items: center;
                      flex: 1;
                      min-width: 0;
                      margin-right: 8px;
                    }

                    .user-name {
                      color: rgba(255, 255, 255, 0.9);
                      font-size: 14px;
                      line-height: 1.4;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      max-width: 120px;
                    }

                    .create-time {
                      color: rgba(255, 255, 255, 0.45);
                      font-size: 12px;
                      line-height: 1.4;
                      white-space: nowrap;
                      flex-shrink: 0;

                      &::before {
                        content: '·';
                        margin: 0 4px;
                      }
                    }

                    .action-btn {
                      margin-left: auto;
                      color: rgba(255, 255, 255, 0.65);
                      font-size: 13px;
                      cursor: pointer;

                      &:hover {
                        color: #11DAB7;
                      }
                    }
                    .icon-delete{
                      color: rgba(255, 255, 255, 1);
                      &:hover {
                        color: #ff4d4f;
                      }
                    }
                  }

                  .reply-content {
                    color: rgba(255, 255, 255, 0.85);
                    font-size: 14px;
                    line-height: 1.6;
                    word-break: break-all;
                  }
                }
              }

              .reply-input-wrapper {
                margin-top: 12px;
                position: relative;

                /deep/ .el-textarea {
                  .el-textarea__inner {
                    padding-right: 40px;
                    background: #292A2C;
                    border: 1px solid #4F4F4F;
                    border-radius: 4px;
                    color: rgba(255, 255, 255, 0.85);
                    font-size: 14px;
                    line-height: 1.6;

                    &::placeholder {
                      color: rgba(255, 255, 255, 0.25);
                    }

                    &:focus {
                      border-color: #11DAB7;
                    }
                  }
                }

                .send-icon {
                  position: absolute;
                  right: 12px;
                  bottom: 8px;
                  font-size: 18px;
                  color: #11DAB7;
                  cursor: pointer;
                  transition: all 0.2s;

                  &:hover:not(.disabled) {
                    transform: scale(1.1);
                  }

                  &.disabled {
                    color: rgba(255, 255, 255, 0.25);
                    cursor: not-allowed;
                  }
                }
              }

              .reply-limit-text {
                color: rgba(255, 255, 255, 0.45);
                font-size: 12px;
                line-height: 1.4;
                text-align: center;
              }
            }
          }
        }

      .empty-content {
        text-align: center;
        padding: 50% 12px 0;
        color: rgba(255, 255, 255, 0.45);

        img {
          margin-bottom: 16px;
        }

        p {
          font-size: 14px;
        }
      }

      .loading-text {
        text-align: center;
        color: rgba(255, 255, 255, 0.45);
        font-size: 13px;
        padding: 12px;
      }
    }
  }

  .annotation-dialog {
    position: fixed;
    width: 260px;
    height: 156px;
    background: #1A1A1A;
    border: 1px solid #4F4F4F;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.5);
    z-index: 101;
    overflow: hidden;

    .dialog-content {
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;

      /deep/ .el-textarea {
        margin-bottom: 0;
        flex: 1;
        display: flex;
        flex-direction: column;

        .el-textarea__inner {
          background: #292A2C;
          border: none;
          border-bottom: 1px solid #4F4F4F;
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
          line-height: 1.6;
          height: 100% !important;
          resize: none;
          padding: 8px 12px;

          &::placeholder {
            color: rgba(255, 255, 255, 0.25);
          }
        }

        .el-input__count {
          background: transparent;
          color: rgba(255, 255, 255, 0.45);
          font-size: 12px;
          line-height: 1;
        }
      }

      .dialog-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 8px;
        flex-shrink: 0;

        .action-left{
          display: flex;
          align-items: center;
          gap: 8px;

          .screenshot-img-sm{
            width: 48px;
            height: 32px;
            background: rgba(214, 224, 235, 1);
            overflow: hidden;
          }

          .assist-btn {
            color: #11DAB7;
            font-size: 12px;
          }
        }

        .action-right {
          /deep/ .el-button {
            min-width: 52px;
            padding: 7px 12px;
            font-size: 12px;

            &:not(.el-button--primary) {
              background: transparent;
              border-color: #4F4F4F;
              color: rgba(255, 255, 255, 0.85);

              &:hover {
                border-color: #11DAB7;
                color: #11DAB7;
              }
            }

            &.el-button--primary {
              background: #11DAB7;
              border-color: #11DAB7;

              &:hover {
                background: #0ec9a6;
                border-color: #0ec9a6;
              }

              &:disabled {
                background: #262626;
                border-color: #262626;
                color: rgba(255, 255, 255, 0.25);
              }
            }
          }
        }
      }
    }
  }
}

/deep/ .red-bg:hover {
  background-color: #ff4d4f;
}
</style>

